import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';

import { AdminPageHeader } from '@/design-system';
import { Commentable } from '@/shared/comments/Commentable';
import { cn } from '@/shared/cn';
import {
  APP_CHROME_CANVAS,
  SURFACE_PAGE_MOBILE_TOP_PAD,
  SURFACE_PAGE_WIDTH_CONTENT,
} from '@/shared/ui-class';
import { useRole } from '@/versions/v1/shared/RoleContext';

import { formatAdminDate, formatAdminDateTime } from './admin-format';

export const CURRENT_USER_ID = 'user-alex';

export { formatAdminDate, formatAdminDateTime };

export function AdminSceneShell({
  sceneName,
  title,
  description,
  headerActions,
  stackClassName = 'space-y-6',
  children,
}: {
  sceneName: string;
  title: string;
  description?: string;
  headerActions?: ReactNode;
  stackClassName?: string;
  children: ReactNode;
}) {
  const { can } = useRole();

  if (!can('roles:admin')) {
    return <Navigate to="/" replace />;
  }

  return (
    <Commentable name={sceneName}>
      <div
        className={cn(
          'flex-1 overflow-y-auto py-8',
          APP_CHROME_CANVAS,
          SURFACE_PAGE_MOBILE_TOP_PAD,
        )}
      >
        <div className={cn(stackClassName, SURFACE_PAGE_WIDTH_CONTENT)}>
          <AdminPageHeader
            title={title}
            description={description}
            actions={headerActions}
          />
          {children}
        </div>
      </div>
    </Commentable>
  );
}
